import React from 'react';
import { Avatar, Layout, Row } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { AccountSwitcher } from '../../components';
import styles from './styles.less';
import { getAvatarUrl } from '../../utils/avatar';

const { Header } = Layout;

class TopHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      avatar: props.user.avatar,
      title: null,
      description: null,
      variable: null,
    };
  }

  componentWillReceiveProps(props) {
    const { avatar } = props.user;
    const stateAvatar = this.state.avatar;
    if (avatar !== stateAvatar) {
      this.setState({ avatar });
    }

    if (props.header) {
      const { title, description, variable } = props.header;
      const stateTitle = this.state.title;
      const stateDescription = this.state.description;
      const stateVariable = this.state.variable;
      if (title !== stateTitle) {
        this.setState({ title });
      }
      if (description !== stateDescription) {
        this.setState({ description });
      }
      if (variable !== stateVariable) {
        this.setState({ variable });
      }
    }
  }

  render() {
    const { avatar, title, description, variable } = this.state;
    let user = this.props.user;
    const selectedClient = this.props.selectedClient;

    if (!user) {
      user = {};
    }

    return (
      <Header className={styles.header}>
        <Row type="flex" justify="space-between">
          <div className={styles.titleSection}>
            {variable && (
              <h2 className={styles.title}>
                {variable}
              </h2>
            )}
            {title && (
              <h2 className={styles.title}>
                <FormattedMessage id={title} />
              </h2>
            )}
            {description && (
              <div className={`mobile-hide ${styles.description}`}>
                <FormattedMessage id={description} />
              </div>
            )}
          </div>

          <div className={styles.userSection}>
            <div className={styles.userDataBlock}>
              <div className={styles.avatarContainer}>
                <Link to="/profile/" className={styles.avatarWrap}>
                  {avatar ?
                    <Avatar
                      className={styles.avatar}
                      src={`${getAvatarUrl(user.client_id ? this.props.coreClientId : null, avatar)}`}
                      size="large"
                    /> : <Avatar type="edit" icon="user" className={styles.avatar} />}
                </Link>
              </div>
            </div>
            <div className={`tablet-hide ${styles.accSwitcher}`}>
              {!user.client && selectedClient && (
                <h4>{selectedClient.name}</h4>
              )}
              <AccountSwitcher />
            </div>

          </div>

        </Row>
      </Header>
    );
  }
}

export default connect(({ app, loading, header }) => ({
  user: app.user,
  selectedClient: app.selectedClient,
  coreClientId: app.defaultUiSettings.core_client_id,
  loading,
  header,
}))(injectIntl(TopHeader));



// WEBPACK FOOTER //
// ./src/components/TopHeader/TopHeader.js